// @flow
import pipe from 'ramda/es/pipe';
import prop from 'ramda/es/prop';
import path from 'ramda/es/path';
import pick from 'ramda/es/pick';

import api from 'app/actions/api';
import action from 'app/common/lib/action';
import { toCamelCase } from 'app/common/lib/object';


export const EMPLOYEES_REQUEST = 'users/EMPLOYEES_REQUEST';
export const EMPLOYEES_SUCCESS = 'users/EMPLOYEES_SUCCESS';
export const EMPLOYEES_FAILURE = 'users/EMPLOYEES_FAILURE';
export const EMPLOYEES_CANCEL = 'users/EMPLOYEES_CANCEL';
export const EMPLOYEES_CLEAR = 'users/EMPLOYEES_CLEAR';

export const dateFormat = 'YYYY-MM-DD';

type Params = {
  status?: number,
  limit?: number,
  offset?: number,
  employee_id?: number,
  search?: string,
  has_identifier?: boolean,
  post_id?: number,
  class_leader?: number,
}

/**
 * Запрос списка сотрудников по параметрам
 * ВОЗМОЖНО ТАКОГО ЗАПРОСА НЕТ
 */
export const employeesFetch = (params: Params) => async (dispatch: Function) => {
  dispatch(action(EMPLOYEES_REQUEST, params));
  try {
    const res = await api.request('journal/employees2', 'get', { params });
    const employees = pipe(
      prop('data'),
      pick(['employees', 'employees_count']),
      toCamelCase
    )(res);
    dispatch(action(EMPLOYEES_SUCCESS, employees));
    return employees;
  } catch (error) {
    if (error instanceof Error) {
      dispatch(action(EMPLOYEES_FAILURE, { err: 'Не удалось получить данные сотрудника', error, params }));
    } else {
      dispatch(action(EMPLOYEES_CANCEL));
    }
    return null;
  }
};


export const EMPLOYEE_REQUEST = 'users/EMPLOYEE_REQUEST';
export const EMPLOYEE_SUCCESS = 'users/EMPLOYEE_SUCCESS';
export const EMPLOYEE_FAILURE = 'users/EMPLOYEE_FAILURE';

/**
 * Запрос одного сотрудника
 * ВОЗМОЖНО ТАКОГО ЗАПРОСА НЕТ
 */
export const employeeFetch = (id: number) => async (dispatch: Function) => {
  const params = { employee_id: id };
  dispatch(action(EMPLOYEE_REQUEST, id));

  try {
    const res = await api('cabinet/employees2', 'get', { params });
    const employee = pipe(
      path(['data', 'employees']),
      toCamelCase
    )(res);
    dispatch(action(EMPLOYEE_SUCCESS, employee));
    return employee;
  } catch (error) {
    dispatch(action(EMPLOYEE_FAILURE, { err: 'Не удалось получить данные сотрудника', error, params }));
    return null;
  }
};
